<template>

  <head>
    <meta charset="utf-8"/>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link href="assets/images/favicon.png" rel="shortcut icon">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
          rel="stylesheet">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->

    <div class="main-content">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18 text-capitalize">New Member Registration</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item"><a href="members.html">Members</a></li>
                    <li class="breadcrumb-item active">Add Member</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- eTransactions table -->

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <p>Fill in the form correctly. Fields with an Asterisk <strong class="text-danger">*</strong> are mandatory fields.</p>
                  <div id="kev-step-form">
                    <!-- <div id=""> -->

                    <nav class="navbar navbar-expand-lg navbar-light bg-light">

                      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                      </button>

                      <div class="collapse navbar-collapse" id="navbarSupportedContent">

                        <ul class="navbar-nav mr-auto">
                          <li class="nav-item active">
                            <a class="nav-link active">1. Applications Details <span class="sr-only">(current)</span></a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link">2. Plot Details</a>
                          </li>

                          <li class="nav-item">
                            <a class="nav-link">3. Billing Details</a>
                          </li>

                        </ul>

                      </div>

                    </nav>

                    <!-- Property details -->
                    <div class="step-cont active-step">
                      <h3>General Application Details</h3>
                      <section>
                        <form>
                          <!-- Tenant type selection -->

                          <div class="row tenant-indidual-type">
                            <div class="col-lg-4 col-md-6">
                              <div class="mb-4">
                                <label for="developmentType" class="form-label">
                                  Development Type <strong class="text-danger">*</strong>
                                </label>
                                <select
                                    id="developmentType"
                                    class="form-select"
                                    title="Select the type of development for your project"
                                    v-model="formData.developmentType"
                                    required
                                >
                                  <optgroup label="Planning">
                                    <option value="">Select Development Type</option>
                                    <option value="subdivision">Subdivision/Amalgamation of land</option>
                                    <option value="landUseChange">Change/Extension of Use of land</option>
                                    <option value="leaseRenewal">Extension/Renewal of Lease of land</option>
                                    <option value="advertising">Outdoor Advertising & Signage</option>
                                    <option value="regularisation">Regularisation of Existing Developments</option>
                                  </optgroup>
                                  <optgroup label="Engineering">
                                    <option value="structuralEngineering">Structural Engineering Designs & Supervision</option>
                                    <option value="civilEngineering">Civil Engineering Designs, works & clearing</option>
                                  </optgroup>
                                  <optgroup label="Architectural">
                                    <option value="newBuildings">New Buildings</option>
                                    <option value="buildingAlterations">Alterations and additions to existing buildings</option>
                                    <option value="demolition">Demolition of Dwellings</option>
                                    <option value="architecturalRegularisation">Regularisation of Existing Developments</option>
                                  </optgroup>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                              <div class="mb-4">
                                <label for="projectTitle" class="form-label">
                                  Project's Title <strong class="text-danger">*</strong>
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="projectTitle"
                                    placeholder="Enter project's descriptive title"
                                    title="Provide a clear and concise title for your development project"
                                    v-model="formData.projectTitle"
                                    required
                                >
                              </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                              <div class="mb-4">
                                <label for="projectValue" class="form-label">
                                  Project's Value
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="projectValue"
                                    placeholder="Enter estimated project value in KES"
                                    title="Provide the total estimated financial value of the project"
                                    v-model="formData.projectValue"
                                >
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-12">
                                <div><hr></div>
                              </div>

                              <div class="col-lg-4 col-md-6">
                                <div class="mb-4">
                                  <label for="professionalType" class="form-label">
                                    Professional Type <strong class="text-danger">*</strong>
                                  </label>
                                  <select
                                      id="professionalType"
                                      class="form-select"
                                      title="Select the type of professional involved in the project"
                                      v-model="formData.professionalType"
                                      required
                                  >
                                    <option value="">Select Professional Type</option>
                                    <option value="architect">Architect</option>
                                    <option value="civilEngineer">Civil Engineer</option>
                                    <option value="structuralEngineer">Structural Engineer</option>
                                    <option value="electricalEngineer">Electrical Engineer</option>
                                    <option value="mechanicalEngineer">Mechanical Engineer</option>
                                    <option value="landSurveyor">Land Surveyor</option>
                                    <option value="urbanPlanner">Urban Planner</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-lg-4 col-md-6">
                                <div class="mb-4">
                                  <label for="certificateNumber" class="form-label">
                                    Professional Certificate Number <strong class="text-danger">*</strong>
                                  </label>
                                  <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="certificateNumber"
                                        placeholder="Enter Professional Certificate Number"
                                        v-model="formData.certificateNumber"
                                        required
                                    >
                                    <button class="btn btn-outline-secondary" type="button" id="searchProfessionalBtn"
                                            title="Search Professional Details"
                                            @click="searchProfessional"
                                            :disabled="searchingProfessional">
                                      <i v-if="!searchingProfessional" class="bx bx-search"></i>
                                      <i v-else class="bx bx-loader bx-spin"></i>
                                    </button>
                                  </div>
                                  <div v-if="professionalSearchError" class="text-danger mt-1 small">
                                    {{ professionalSearchError }}
                                  </div>
                                </div>
                              </div>

                              <div class="col-lg-4 col-md-6">
                                <div class="mb-4">
                                  <label for="fullNames" class="form-label">Full Names</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="fullNames"
                                      placeholder="Professional's Full Names"
                                      v-model="formData.professionalFullNames"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-lg-4 col-md-6">
                                <div class="mb-4">
                                  <label for="otherNames" class="form-label">Other Names</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="otherNames"
                                      placeholder="Other Names (if any)"
                                      v-model="formData.professionalOtherNames"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-lg-4 col-md-6">
                                <div class="mb-4">
                                  <label for="phoneNumber" class="form-label">Phone Number</label>
                                  <input
                                      type="tel"
                                      class="form-control"
                                      id="phoneNumber"
                                      placeholder="Professional's Phone Number"
                                      v-model="formData.professionalPhoneNumber"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-lg-4 col-md-6">
                                <div class="mb-4">
                                  <label for="emailAddress" class="form-label">Email Address</label>
                                  <input
                                      type="email"
                                      class="form-control"
                                      id="emailAddress"
                                      placeholder="Professional's Email Address"
                                      v-model="formData.professionalEmail"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-lg-4 col-md-6">
                                <div class="mb-4">
                                  <label for="idNumber" class="form-label">ID Number</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="idNumber"
                                      placeholder="Professional's ID Number"
                                      v-model="formData.professionalIdNumber"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-12 mb-4 mt-4">
                                <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#addProfessionalModal">
                                  <i class="bx bx-plus me-2"></i>Add New Professional
                                </button>
                              </div>

                              <div class="col-12">
                                <div><hr></div>
                              </div>
                            </div>
                          </div>

                        </form>
                      </section>
                    </div>
                    <!-- next of kin and dependents -->
                    <div class="step-cont d-none">

                      <section>
                        <form>
                          <div class="row">

                            <div class="col-12">
                              <div class="bg-primary border-2 bg-soft p-3 mb-4">
                                <p class="fw-semibold mb-0 pb-0">Plot Details</p>

                              </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                              <div class="mb-4">
                                <label for="plotNumber" class="form-label">
                                  Plot Number <strong class="text-danger">*</strong>
                                </label>
                                <div class="input-group">
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="plotNumber"
                                      placeholder="Enter Plot Number"
                                      v-model="plotNumber"
                                      required
                                  >
                                  <button
                                      class="btn btn-secondary"
                                      type="button"
                                      id="searchPlotBtn"
                                      title="Search Plot Details"
                                      @click="searchPlot"
                                      :disabled="searchingPlot"
                                  >
                                    <i v-if="!searchingPlot" class="bx bx-search"></i>
                                    <i v-else class="bx bx-loader bx-spin"></i>
                                  </button>
                                </div>
                                <div v-if="plotSearchError" class="text-danger mt-1 small">
                                  {{ plotSearchError }}
                                </div>
                              </div>
                            </div>

                            <div id="plotDetailsSection" class="row g-3" v-show="showPlotDetails">
                              <div class="col-12">
                                <h5 class="mb-3 text-primary">Plot Details</h5>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">UPN Number</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="upnNumber"
                                      v-model="formData.plotDetails.upnNumber"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Plot Size</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="plotSize"
                                      v-model="formData.plotDetails.plotSize"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Land Value</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="landValue"
                                      v-model="formData.plotDetails.landValue"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Annual Land Rate Charges</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="annualLandRateCharges"
                                      v-model="formData.plotDetails.annualLandRateCharges"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Current Balance</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      :class="{'text-danger fw-bold': parseFloat(formData.plotDetails.currentBalance) > 0, 'text-success fw-bold': parseFloat(formData.plotDetails.currentBalance) < 0}"
                                      id="currentBalance"
                                      v-model="formData.plotDetails.currentBalance"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Land Type</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="landType"
                                      v-model="formData.plotDetails.landType"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Land Use</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="landUse"
                                      v-model="formData.plotDetails.landUse"
                                      readonly
                                  >
                                </div>
                              </div>

                              <div class="col-12 mt-4">
                                <div class="bg-primary border-2 bg-soft p-3 mb-4">
                                  <p class="fw-semibold mb-0 pb-0">Owner Details</p>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Full Names</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="ownerFullNames"
                                      v-model="formData.plotDetails.ownerFullNames"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">ID/Passport Number</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="ownerIdNumber"
                                      v-model="formData.plotDetails.ownerIdNumber"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Phone Number</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="ownerPhoneNumber"
                                      v-model="formData.plotDetails.ownerPhoneNumber"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Email Address</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="ownerEmail"
                                      v-model="formData.plotDetails.ownerEmail"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">KRA PIN Number</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="ownerKraPin"
                                      v-model="formData.plotDetails.ownerKraPin"
                                      readonly
                                  >
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label class="form-label">Sub County</label>
                                  <select
                                      class="form-select"
                                      id="subCounty"
                                      v-model="formData.plotDetails.subCounty"
                                      disabled
                                  >
                                    <option value="">Select Sub County</option>
                                    <option value="homabay_town">Homabay Town</option>
                                    <option value="ndhiwa">Ndhiwa</option>
                                    <option value="mbita">Mbita</option>
                                    <option value="rachuonyo_north">Rachuonyo North</option>
                                    <option value="rachuonyo_south">Rachuonyo South</option>
                                    <option value="suba_north">Suba North</option>
                                    <option value="suba_south">Suba South</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label class="form-label">Ward</label>
                                  <select
                                      class="form-select"
                                      id="ward"
                                      v-model="formData.plotDetails.ward"
                                      disabled
                                  >
                                    <option value="">Select Ward</option>
                                    <option v-for="ward in wards" :key="ward.wardID" :value="ward.wardID">
                                      {{ ward.wardName }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label class="form-label">Address</label>
                                  <input
                                      type="text"
                                      class="form-control"
                                      id="ownerAddress"
                                      v-model="formData.plotDetails.ownerAddress"
                                      readonly
                                  >
                                </div>
                              </div>

                              <div class="col-sm-12 col-md-12">
                                <div class="form-group">
                                  <label for="projectDescription">Project Description<strong class="text-danger">*</strong></label>
                                  <textarea
                                      id="projectDescription"
                                      class="form-control"
                                      rows="3"
                                      placeholder="Brief description of the project"
                                      v-model="formData.projectDescription"
                                      required
                                  ></textarea>
                                </div>
                              </div>

                              <!-- Project Documents Section -->
                              <div class="col-12 mt-4">
                                <div class="bg-warning border-2 bg-soft p-3 mb-4">
                                  <p class="fw-semibold mb-0 pb-0">Project Documents</p>
                                  <small class="text-muted">Upload required documents for your application. Files should be in PDF, JPG, PNG, DWG, or DXF format and not exceed 10MB.</small>
                                </div>

                                <div class="mb-4">
                                  <button type="button" class="btn btn-primary" @click="addDocument">
                                    <i class="bx bx-plus me-2"></i>Add Document
                                  </button>
                                </div>

                                <div v-if="uploadedDocuments.length === 0" class="alert alert-info">
                                  No documents added yet. Click the "Add Document" button to upload required documents.
                                </div>

                                <div v-for="doc in uploadedDocuments" :key="doc.id" class="card mb-3">
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-md-4 mb-3">
                                        <label :for="'docType_' + doc.id" class="form-label">Document Type <strong class="text-danger">*</strong></label>
                                        <select
                                            :id="'docType_' + doc.id"
                                            class="form-select"
                                            v-model="doc.documentType"
                                            required
                                        >
                                          <option value="">Select Document Type</option>
                                          <option v-for="type in documentTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                                        </select>
                                      </div>

                                      <div class="col-md-4 mb-3">
                                        <label :for="'docNumber_' + doc.id" class="form-label">Document Number</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :id="'docNumber_' + doc.id"
                                            v-model="doc.documentNumber"
                                            placeholder="Enter document number (if applicable)"
                                        >
                                      </div>

                                      <div class="col-md-4 mb-3">
                                        <label :for="'docExpiry_' + doc.id" class="form-label">Expiry Date</label>
                                        <input
                                            type="date"
                                            class="form-control"
                                            :id="'docExpiry_' + doc.id"
                                            v-model="doc.expiryDate"
                                        >
                                      </div>

                                      <div class="col-md-8 mb-3">
                                        <label :for="doc.fileId" class="form-label">File <strong class="text-danger">*</strong></label>
                                        <div class="input-group">
                                          <input
                                              type="file"
                                              class="form-control"
                                              :id="doc.fileId"
                                              @change="(e) => handleDocumentChange(doc.id, e)"
                                              accept=".pdf,.jpg,.jpeg,.png,.dwg,.dxf"
                                              required
                                          >
                                          <button
                                              class="btn btn-outline-danger"
                                              type="button"
                                              @click="removeDocument(doc.id)"
                                              title="Remove Document"
                                          >
                                            <i class="bx bx-trash"></i>
                                          </button>
                                        </div>
                                        <div v-if="doc.error" class="text-danger mt-1 small">{{ doc.error }}</div>
                                        <div v-if="doc.fileName" class="text-muted mt-1 small">
                                          {{ doc.fileName }} ({{ (doc.fileSize / 1024 / 1024).toFixed(2) }} MB)
                                        </div>
                                      </div>

                                      <div v-if="doc.uploadProgress > 0 && doc.uploadProgress < 100" class="col-12">
                                        <div class="progress" style="height: 5px;">
                                          <div
                                              class="progress-bar progress-bar-striped progress-bar-animated"
                                              role="progressbar"
                                              :style="{ width: doc.uploadProgress + '%' }"
                                              :aria-valuenow="doc.uploadProgress"
                                              aria-valuemin="0"
                                              aria-valuemax="100"
                                          ></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </section>
                    </div>

                    <!-- Billing Section -->
                    <div class="step-cont d-none" id="billing-section">
                      <h3>Payments And Confirmation</h3>
                      <section>

                        <div class="row">
                          <!-- Left side - Enter bill details -->
                          <div class="col-md-6">
                            <div class="card">
                              <div class="card-body">
                                <h5 class="card-title mb-4">Enter the invoice details below</h5>

                                <!-- Income Type Selection -->
                                <div class="mb-3">
                                  <label for="incomeType" class="form-label">Income Type</label>
                                  <select
                                      class="form-select"
                                      id="incomeType"
                                      v-model="selectedIncomeType"
                                      :disabled="loadingIncomeTypes"
                                  >
                                    <option value="">Select Income Type</option>
                                    <option v-if="loadingIncomeTypes" value="" disabled>Loading...</option>
                                    <option
                                        v-for="type in incomeTypes"
                                        :key="type.incomeTypeId"
                                        :value="type.incomeTypeId"
                                    >
                                      {{ type.incomeTypeDescription }}
                                    </option>
                                  </select>
                                  <div v-if="loadingIncomeTypes" class="text-muted small mt-1">
                                    <i class="bx bx-loader bx-spin"></i> Loading income types...
                                  </div>
                                </div>

                                <!-- Fees and Charges Selection -->
                                <div class="mb-3">
                                  <label for="feeAndCharge" class="form-label">Account Name</label>
                                  <select
                                      class="form-select"
                                      id="feeAndCharge"
                                      v-model="selectedFeeAndCharge"
                                      :disabled="!selectedIncomeType || loadingFeesAndCharges"
                                  >
                                    <option value="">Select Fee/Charge</option>
                                    <option v-if="loadingFeesAndCharges" value="" disabled>Loading...</option>
                                    <option
                                        v-for="fee in feesAndCharges"
                                        :key="fee.feeId"
                                        :value="fee.feeId"
                                    >
                                      {{ fee.feeDescription }} ({{ fee.currency }} {{ fee.unitFeeAmount }})
                                    </option>
                                  </select>
                                  <div v-if="loadingFeesAndCharges" class="text-muted small mt-1">
                                    <i class="bx bx-loader bx-spin"></i> Loading fees and charges...
                                  </div>
                                  <div v-if="!selectedIncomeType && !loadingIncomeTypes" class="text-muted small mt-1">
                                    Please select an Income Type first
                                  </div>
                                </div>

                                <!-- Details -->
                                <div class="mb-3">
                                  <label for="details" class="form-label">Details</label>
                                  <textarea
                                      id="details"
                                      class="form-control"
                                      rows="3"
                                      v-model="billingForm.details"
                                      placeholder="Description of the charge"
                                  ></textarea>
                                </div>

                                <div class="row">
                                  <!-- Quantity -->
                                  <div class="col-md-6 mb-3">
                                    <label for="quantity" class="form-label">Quantity</label>
                                    <input
                                        type="number"
                                        id="quantity"
                                        class="form-control"
                                        v-model="billingForm.quantity"
                                        min="1"
                                    >
                                  </div>

                                  <!-- Amount -->
                                  <div class="col-md-6 mb-3">
                                    <label for="amount" class="form-label">Amount</label>
                                    <div class="input-group">
                                      <span class="input-group-text">KES</span>
                                      <input
                                          type="number"
                                          id="amount"
                                          class="form-control"
                                          v-model="billingForm.amount"
                                          readonly
                                      >
                                    </div>
                                  </div>
                                </div>

                                <!-- Add Button -->
                                <button
                                    class="btn btn-primary"
                                    @click="addBillItem"
                                    :disabled="!selectedIncomeType || !selectedFeeAndCharge"
                                >
                                  <i class="bx bx-plus me-1"></i> Add Bill Item
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Right side - Created Bill Details -->
                          <div class="col-md-6">
                            <div class="card">
                              <div class="card-body">
                                <h5 class="card-title mb-4">Created Bill Details</h5>

                                <div class="table-responsive">
                                  <table class="table table-bordered">
                                    <thead class="table-light">
                                    <tr>
                                      <th>No.</th>
                                      <th>Details</th>
                                      <th class="text-end">Amount</th>
                                      <th class="text-center">Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="billItems.length === 0">
                                      <td colspan="4" class="text-center py-3">No items added to bill yet</td>
                                    </tr>
                                    <tr v-for="(item, index) in billItems" :key="item.id">
                                      <td>{{ index + 1 }}</td>
                                      <td>
                                        {{ item.feeDescription }}
                                        <small class="d-block text-muted">{{ item.incomeTypeDescription }}</small>
                                      </td>
                                      <td class="text-end">
                                        {{ item.currency || 'KES' }} {{ item.totalAmount }}
                                        <small class="d-block text-muted">({{ item.quantity }} × {{ item.unitAmount }})</small>
                                      </td>
                                      <td class="text-center">
                                        <button
                                            class="btn btn-sm btn-outline-danger mx-1"
                                            title="Remove"
                                            @click="removeBillItem(item.id)"
                                        >
                                          <i class="bx bx-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                    </tbody>
                                    <tfoot v-if="billItems.length > 0">
                                    <tr class="fw-bold">
                                      <td colspan="2" class="text-end">Total:</td>
                                      <td class="text-end">KES {{ calculateTotalAmount() }}</td>
                                      <td></td>
                                    </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                      </section>
                    </div>

                    <div class="button-navigators">
                      <button disabled class="btn btn-primary waves-effect kev-prev me-3"><i class="mdi-arrow-left mdi font-16px ms-2 me-2"></i> Previous </button>
                      <button class="btn btn-primary waves-effect kev-nxt me-3">Next <i class="mdi mdi-arrow-right font-16px ms-2 me-2"></i></button>
                      <button @click="submitApplication" :disabled="billItems.length === 0" type='button' class="btn btn-success kev-submit me-3 d-none">Submit <i class="mdi mdi-check-all me-2 font-16px"></i></button>
                    </div>
                  </div>
                </div>
                <!-- end card body -->
              </div>
              <!-- end card -->
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Footer and modals remain the same -->
      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Hotline Transporters Sacco
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Add Professional Modal -->
  <div class="modal fade" id="addProfessionalModal" tabindex="-1" aria-labelledby="addProfessionalModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addProfessionalModalLabel">Add New Professional</h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="submitMessage" class="alert" :class="{ 'alert-success': submitStatus === 'success', 'alert-danger': submitStatus === 'error' }">
            {{ submitMessage }}
          </div>

          <form id="addProfessionalForm" @submit.prevent="addProfessional">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="modalProfessionalType" class="form-label">Professional Type <strong class="text-danger">*</strong></label>
                <select
                    id="modalProfessionalType"
                    class="form-select"
                    v-model="professionalForm.professionalType"
                    :class="{'is-invalid': formErrors.professionalType}"
                    required
                >
                  <option value="">Select Professional Type</option>
                  <option value="architect">Architect</option>
                  <option value="civilEngineer">Civil Engineer</option>
                  <option value="structuralEngineer">Structural Engineer</option>
                  <option value="electricalEngineer">Electrical Engineer</option>
                  <option value="mechanicalEngineer">Mechanical Engineer</option>
                  <option value="landSurveyor">Land Surveyor</option>
                  <option value="urbanPlanner">Urban Planner</option>
                </select>
                <div v-if="formErrors.professionalType" class="invalid-feedback">
                  {{ formErrors.professionalType }}
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="modalCertificateNumber" class="form-label">Certificate Number <strong class="text-danger">*</strong></label>
                <input
                    type="text"
                    class="form-control"
                    id="modalCertificateNumber"
                    v-model="professionalForm.certificateNumber"
                    :class="{'is-invalid': formErrors.certificateNumber}"
                    placeholder="Enter Certificate Number"
                    required
                >
                <div v-if="formErrors.certificateNumber" class="invalid-feedback">
                  {{ formErrors.certificateNumber }}
                </div>
              </div>

              <!-- Continue with other form fields -->
              <div class="col-md-6 mb-3">
                <label for="modalFullNames" class="form-label">Full Names <strong class="text-danger">*</strong></label>
                <input
                    type="text"
                    class="form-control"
                    id="modalFullNames"
                    v-model="professionalForm.fullNames"
                    :class="{'is-invalid': formErrors.fullNames}"
                    placeholder="Enter Full Names"
                    required
                >
                <div v-if="formErrors.fullNames" class="invalid-feedback">
                  {{ formErrors.fullNames }}
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="modalOtherNames" class="form-label">Other Names</label>
                <input
                    type="text"
                    class="form-control"
                    id="modalOtherNames"
                    v-model="professionalForm.otherNames"
                    placeholder="Enter Other Names"
                >
              </div>

              <div class="col-md-6 mb-3">
                <label for="modalPhoneNumber" class="form-label">Phone Number <strong class="text-danger">*</strong></label>
                <input
                    type="tel"
                    class="form-control"
                    id="modalPhoneNumber"
                    v-model="professionalForm.phoneNumber"
                    :class="{'is-invalid': formErrors.phoneNumber}"
                    placeholder="Enter Phone Number"
                    required
                >
                <div v-if="formErrors.phoneNumber" class="invalid-feedback">
                  {{ formErrors.phoneNumber }}
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="modalEmailAddress" class="form-label">Email Address <strong class="text-danger">*</strong></label>
                <input
                    type="email"
                    class="form-control"
                    id="modalEmailAddress"
                    v-model="professionalForm.emailAddress"
                    :class="{'is-invalid': formErrors.emailAddress}"
                    placeholder="Enter Email Address"
                    required
                >
                <div v-if="formErrors.emailAddress" class="invalid-feedback">
                  {{ formErrors.emailAddress }}
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="modalIdNumber" class="form-label">ID Number <strong class="text-danger">*</strong></label>
                <input
                    type="text"
                    class="form-control"
                    id="modalIdNumber"
                    v-model="professionalForm.idNumber"
                    :class="{'is-invalid': formErrors.idNumber}"
                    placeholder="Enter ID Number"
                    required
                >
                <div v-if="formErrors.idNumber" class="invalid-feedback">
                  {{ formErrors.idNumber }}
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="modalCertificationFile" class="form-label">Professional Certification <strong class="text-danger">*</strong></label>
                <input
                    type="file"
                    class="form-control"
                    id="modalCertificationFile"
                    @change="handleFileChange"
                    :class="{'is-invalid': formErrors.certificationFile}"
                    accept=".pdf,.jpg,.jpeg,.png"
                    required
                >
                <div v-if="formErrors.certificationFile" class="invalid-feedback">
                  {{ formErrors.certificationFile }}
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="modalCertificationExpiry" class="form-label">Certification Expiry Date <strong class="text-danger">*</strong></label>
                <input
                    type="date"
                    class="form-control"
                    id="modalCertificationExpiry"
                    v-model="professionalForm.certificationExpiry"
                    :class="{'is-invalid': formErrors.certificationExpiry}"
                    required
                >
                <div v-if="formErrors.certificationExpiry" class="invalid-feedback">
                  {{ formErrors.certificationExpiry }}
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
                <span v-if="isSubmitting" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                {{ isSubmitting ? 'Saving...' : 'Save Professional' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */

import NavigationBar from "@/components/Navigation";
import {execute, econstruction, biller, rent} from "@/api";

export default {
  name: "eConstructionApplication",
  components: { NavigationBar },
  data() {
    return {
      // Main form data object to hold all form values
      formData: {
        // Application Details
        developmentType: '',
        projectTitle: '',
        projectValue: '',
        projectDescription: '',

        // Professional Details
        professionalType: '',
        certificateNumber: '',
        professionalFullNames: '',
        professionalOtherNames: '',
        professionalPhoneNumber: '',
        professionalEmail: '',
        professionalIdNumber: '',
        professionalId: null,

        // Plot Details
        plotDetails: {
          upnNumber: '',
          plotSize: '',
          landValue: '',
          annualLandRateCharges: '',
          currentBalance: '',
          landType: '',
          landUse: '',
          ownerFullNames: '',
          ownerIdNumber: '',
          ownerPhoneNumber: '',
          ownerEmail: '',
          ownerKraPin: '',
          ownerAddress: '',
          subCounty: '',
          ward: ''
        }
      },

      businessDetailsResult: {},
      professionalForm: {
        professionalType: '',
        certificateNumber: '',
        fullNames: '',
        otherNames: '',
        phoneNumber: '',
        emailAddress: '',
        idNumber: '',
        certificationExpiry: '',
        certificationFile: null
      },
      formErrors: {},
      isSubmitting: false,
      submitMessage: '',
      submitStatus: null,
      searchingProfessional: false,
      professionalSearchError: '',

      // Plot search related data
      plotNumber: '',
      searchingPlot: false,
      plotSearchError: '',
      plotDetails: {
        id: null,
        UPN: null,
        LRNumber: null,
        subCountyName: null,
        subCountyID: null,
        wardName: null,
        wardID: null,
        percelSize: null,
        // other properties as in original code
      },
      showPlotDetails: false,

      // Location data
      subCounties: [],
      wards: [],
      loadingSubCounties: false,
      loadingWards: false,
      selectedSubCounty: '',

      // Billing related data
      incomeTypes: [],
      feesAndCharges: [],
      loadingIncomeTypes: false,
      loadingFeesAndCharges: false,
      selectedIncomeType: null,
      selectedFeeAndCharge: null,
      billItems: [],
      billItem: [],
      billingForm: {
        quantity: 1,
        amount: 0,
        details: ''
      },

      generatedBillNo: null,
      applicationId: null,
      applicationNumber: null,

      // Document upload related properties
      documentTypes: [
        { id: 'landOwnership', name: 'Land Ownership Documents' },
        { id: 'consent', name: 'Consent Letter' },
        { id: 'architecturalDrawings', name: 'Architectural Drawings' },
        { id: 'structuralPlans', name: 'Structural Engineering Plans' },
        { id: 'approvalForms', name: 'Approval Forms' },
        { id: 'otherDocuments', name: 'Other Supporting Documents' }
      ],
      uploadedDocuments: [],
      uploadingDocument: false
    }
  },
  watch: {
    // Watch for changes to professional type in the main form
    'formData.professionalType': function(newVal) {
      // Reset professional fields if type changes
      if (this.professional && this.professional.professionalType !== newVal) {
        this.resetProfessionalFields();
      }
    },

    selectedSubCounty(newVal) {
      if (newVal) {
        this.loadWards(newVal);
      } else {
        this.wards = [];
      }
    },

    selectedIncomeType(newVal) {
      if (newVal) {
        this.loadFeesAndCharges(newVal);
      } else {
        this.feesAndCharges = [];
        this.selectedFeeAndCharge = null;
      }
    },

    // Watch for changes to selected fee and charge
    selectedFeeAndCharge(newVal) {
      if (newVal) {
        // Find the fee and charge object using string comparison
        const fee = this.feesAndCharges.find(fee => String(fee.feeId) === String(newVal));

        if (fee) {
          // Update the amount field - convert to number for calculation
          this.billingForm.amount = Number(fee.unitFeeAmount);

          // Update the details field with the fee description
          this.billingForm.details = fee.feeDescription;
        }
      } else {
        this.billingForm.amount = 0;
        this.billingForm.details = '';
      }
    }

  },

  mounted() {
    // Initialize any required event listeners for the modal
    $('#addProfessionalModal').on('hidden.bs.modal', this.resetProfessionalForm);

    // Load sub counties when component mounts
    this.loadSubCounties();

    // Load income types for billing
    this.loadIncomeTypes();
  },

  methods: {

    searchProfessional() {
      const professionalType = this.formData.professionalType;
      const certificateNumber = this.formData.certificateNumber;

      if (!certificateNumber) {
        this.professionalSearchError = 'Please enter a certificate number';
        return;
      }

      this.searchingProfessional = true;
      this.professionalSearchError = '';

      const data = new FormData();
      data.append("function", "searchProfessional");
      data.append("professionalType", professionalType);
      data.append("certificateNumber", certificateNumber);

      execute(data, econstruction)
          .then((res) => {
            this.searchingProfessional = false;

            if (res.data.success) {
              // Populate the form fields with the professional's information
              const professional = res.data.data.professional;

              // Using v-model instead of direct DOM manipulation
              this.formData.professionalFullNames = professional.full_names || '';
              this.formData.professionalOtherNames = professional.other_names || '';
              this.formData.professionalPhoneNumber = professional.phone_number || '';
              this.formData.professionalEmail = professional.email_address || '';
              this.formData.professionalIdNumber = professional.id_number || '';
              this.formData.professionalId = professional.id || null;

              // Clear any previous error
              this.professionalSearchError = '';

              // If there's a toast or notification system, show success message
              if (this.$toast) {
                this.$toast.success(res.data.message);
              }
            } else {
              // Reset the fields since no professional was found
              this.resetProfessionalFields();

              // Set the error message so it can be displayed in the UI
              this.professionalSearchError = res.data.message || 'Professional not found';

              // If there's a toast or notification system, show error message
              if (this.$toast) {
                this.$toast.error(res.data.message);
              }
            }
          })
          .catch((e) => {
            this.searchingProfessional = false;
            this.professionalSearchError = e.message || 'An error occurred while searching for the professional';

            // Reset the fields since search failed
            this.resetProfessionalFields();

            // If there's a toast or notification system, show error message
            if (this.$toast) {
              this.$toast.error(this.professionalSearchError);
            }
          });
    },

    resetProfessionalFields() {
      // Reset professional fields using v-model approach
      this.formData.professionalFullNames = '';
      this.formData.professionalOtherNames = '';
      this.formData.professionalPhoneNumber = '';
      this.formData.professionalEmail = '';
      this.formData.professionalIdNumber = '';
      this.formData.professionalId = null;
    },

    // Search plot functionality
    searchPlot() {
      if (!this.plotNumber) {
        this.plotSearchError = 'Please enter a plot number';
        return;
      }

      this.searchingPlot = true;
      this.plotSearchError = '';
      this.showPlotDetails = false;

      const data = new FormData();
      data.append("function", "searchPlot");
      data.append("plotNumber", this.plotNumber);

      execute(data, econstruction)
          .then((res) => {
            this.searchingPlot = false;

            if (res.data.success) {
              // Store plot details and show the details section
              this.plotDetails = res.data.data.plot;
              this.showPlotDetails = true;

              // Update formData with plot details
              this.populatePlotDetails(this.plotDetails);

              // If there's a toast or notification system, show success message
              if (this.$toast) {
                this.$toast.success(res.data.message);
              }
            } else {
              // Hide plot details section and show error
              this.showPlotDetails = false;
              this.plotDetails = null;
              this.plotSearchError = res.data.message;

              // Reset plot fields
              this.resetPlotFields();

              // If there's a toast or notification system, show error message
              if (this.$toast) {
                this.$toast.error(res.data.message);
              }
            }
          })
          .catch((e) => {
            this.searchingPlot = false;
            this.showPlotDetails = false;
            this.plotDetails = null;
            this.plotSearchError = e.message || 'An error occurred while searching for the plot';

            // Reset plot fields
            this.resetPlotFields();

            // If there's a toast or notification system, show error message
            if (this.$toast) {
              this.$toast.error(this.plotSearchError);
            }
          });
    },

    populatePlotDetails(plotData) {
      // Using v-model instead of direct DOM manipulation
      this.formData.plotDetails.upnNumber = plotData.UPN || 'N/A';
      this.formData.plotDetails.plotSize = plotData.percelSize || 'N/A';
      this.formData.plotDetails.landValue = 'N/A'; // Not available in sample
      this.formData.plotDetails.annualLandRateCharges = plotData.annualCharges || '0';
      this.formData.plotDetails.currentBalance = plotData.outstandingArrears || '0';
      this.formData.plotDetails.landType = plotData.block || 'N/A';
      this.formData.plotDetails.landUse = plotData.useName || 'N/A';
      this.formData.plotDetails.ownerFullNames = plotData.ownerNames || 'N/A';
      this.formData.plotDetails.ownerIdNumber = plotData.ownerID || 'N/A';
      this.formData.plotDetails.ownerPhoneNumber = plotData.ownerPhoneNo || 'N/A';
      this.formData.plotDetails.ownerEmail = plotData.ownerEmail || 'N/A';
      this.formData.plotDetails.ownerKraPin = plotData.pinNumber || 'N/A';

      // Handle address
      let address = plotData.percelAddress || '';
      if (plotData.physicalAddress) {
        address += address ? ', ' + plotData.physicalAddress : plotData.physicalAddress;
      }
      this.formData.plotDetails.ownerAddress = address || 'N/A';

      // Handle dropdown fields for subCounty and ward
      if (plotData.subCountyID && plotData.subCountyName) {
        this.formData.plotDetails.subCounty = plotData.subCountyID;
        this.selectedSubCounty = plotData.subCountyID;

        // If we also have ward information
        if (plotData.wardID && plotData.wardName) {
          // Wait for wards to load
          setTimeout(() => {
            this.formData.plotDetails.ward = plotData.wardID;
          }, 300);
        }
      }
    },

    resetPlotFields() {
      // Reset plot fields using v-model approach
      this.formData.plotDetails = {
        upnNumber: '',
        plotSize: '',
        landValue: '',
        annualLandRateCharges: '',
        currentBalance: '',
        landType: '',
        landUse: '',
        ownerFullNames: '',
        ownerIdNumber: '',
        ownerPhoneNumber: '',
        ownerEmail: '',
        ownerKraPin: '',
        ownerAddress: '',
        subCounty: '',
        ward: ''
      };

      this.selectedSubCounty = '';
    },

    // Load sub counties from the API
    loadSubCounties() {
      this.loadingSubCounties = true;

      const data = new FormData();
      data.append("function", "getSubCounty");

      execute(data, econstruction)
          .then((res) => {
            this.loadingSubCounties = false;

            if (res.data.success && res.data.data && res.data.data.subCounties) {
              this.subCounties = res.data.data.subCounties;
            } else {
              console.error("Failed to load sub counties");
              if (this.$toast) {
                this.$toast.error("Failed to load sub counties");
              }
            }
          })
          .catch((e) => {
            this.loadingSubCounties = false;
            console.error("Error loading sub counties:", e);
            if (this.$toast) {
              this.$toast.error("Error loading sub counties: " + (e.message || "Unknown error"));
            }
          });
    },

    // Load wards based on selected sub county
    loadWards(subCountyId) {
      this.loadingWards = true;
      this.wards = [];

      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyId);

      execute(data, econstruction)
          .then((res) => {
            this.loadingWards = false;

            if (res.data.success && res.data.data && res.data.data.wards) {
              this.wards = res.data.data.wards;
            } else {
              console.error("Failed to load wards");
              if (this.$toast) {
                this.$toast.error("Failed to load wards");
              }
            }
          })
          .catch((e) => {
            this.loadingWards = false;
            console.error("Error loading wards:", e);
            if (this.$toast) {
              this.$toast.error("Error loading wards: " + (e.message || "Unknown error"));
            }
          });
    },

    // Load income types from API
    loadIncomeTypes() {
      this.loadingIncomeTypes = true;

      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "PLANS");

      execute(data, biller)
          .then((res) => {
            this.loadingIncomeTypes = false;

            if (res.data.success && res.data.data && res.data.data.incomeTypes) {
              this.incomeTypes = res.data.data.incomeTypes;
            } else {
              console.error("Failed to load income types");
              if (this.$toast) {
                this.$toast.error("Failed to load income types");
              }
            }
          })
          .catch((e) => {
            this.loadingIncomeTypes = false;
            console.error("Error loading income types:", e);
            if (this.$toast) {
              this.$toast.error("Error loading income types: " + (e.message || "Unknown error"));
            }
          });
    },

    // Load fees and charges based on selected income type
    loadFeesAndCharges(incomeTypeId) {
      this.loadingFeesAndCharges = true;
      this.feesAndCharges = [];
      this.selectedFeeAndCharge = null;

      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);

      execute(data, biller)
          .then((res) => {
            this.loadingFeesAndCharges = false;

            if (res.data.success && res.data.data && res.data.data.feesAndCharges) {
              this.feesAndCharges = res.data.data.feesAndCharges;
            } else {
              console.error("Failed to load fees and charges");
              if (this.$toast) {
                this.$toast.error("Failed to load fees and charges");
              }
            }
          })
          .catch((e) => {
            this.loadingFeesAndCharges = false;
            console.error("Error loading fees and charges:", e);
            if (this.$toast) {
              this.$toast.error("Error loading fees and charges: " + (e.message || "Unknown error"));
            }
          });
    },

    // Add item to bill
    addBillItem2() {
      if (!this.selectedIncomeType || !this.selectedFeeAndCharge) {
        if (this.$toast) {
          this.$toast.error("Please select an income type and fee");
        }
        return;
      }

      // Find the income type and fee objects
      const incomeType = this.incomeTypes.find(type => type.incomeTypeId === parseInt(this.selectedIncomeType));
      const fee = this.feesAndCharges.find(fee => fee.feeId === parseInt(this.selectedFeeAndCharge));

      if (!incomeType || !fee) {
        if (this.$toast) {
          this.$toast.error("Selected income type or fee not found");
        }
        return;
      }

      // Calculate total amount
      const totalAmount = parseFloat(this.billingForm.quantity) * parseFloat(fee.unitFeeAmount);

      // Create bill item
      const billItem = {
        id: Date.now(), // Unique ID for the item
        incomeTypeId: incomeType.incomeTypeId,
        incomeTypeDescription: incomeType.incomeTypeDescription,
        feeId: fee.feeId,
        feeDescription: fee.feeDescription,
        quantity: this.billingForm.quantity,
        unitAmount: fee.unitFeeAmount,
        totalAmount: totalAmount,
        details: this.billingForm.details
      };

      // Add to bill items
      this.billItems.push(billItem);

      // Reset form
      this.resetBillingForm();

      // Show success message
      if (this.$toast) {
        this.$toast.success("Item added to bill");
      }
    },

    addBillItem() {
      if (!this.selectedIncomeType || !this.selectedFeeAndCharge) {
        if (this.$toast) {
          this.$toast.error("Please select an income type and fee");
        }
        return;
      }

      // Find the income type and fee objects using more flexible comparison
      const incomeType = this.incomeTypes.find(type =>
          String(type.incomeTypeId) === String(this.selectedIncomeType)
      );

      const fee = this.feesAndCharges.find(fee =>
          String(fee.feeId) === String(this.selectedFeeAndCharge)
      );

      if (!incomeType || !fee) {
        if (this.$toast) {
          this.$toast.error("Selected income type or fee not found");
        }
        console.error("Income type or fee not found:", {
          selectedIncomeType: this.selectedIncomeType,
          foundIncomeType: incomeType,
          selectedFeeAndCharge: this.selectedFeeAndCharge,
          foundFee: fee
        });
        return;
      }

      // Calculate total amount
      const totalAmount = parseFloat(this.billingForm.quantity) * parseFloat(fee.unitFeeAmount);

      // Create bill item
      const billItem = {
        id: Date.now(), // Unique ID for the item
        incomeTypeId: incomeType.incomeTypeId,
        incomeTypeDescription: incomeType.incomeTypeDescription,
        feeId: fee.feeId,
        feeDescription: fee.feeDescription,
        quantity: this.billingForm.quantity,
        unitAmount: fee.unitFeeAmount,
        totalAmount: totalAmount,
        details: this.billingForm.details,
        currency: fee.currency || 'KES' // Make sure currency is included
      };

      console.log("Adding bill item:", billItem);

      // Add to bill items
      this.billItems.push(billItem);

      // Reset form
      this.resetBillingForm();

      // Show success message
      if (this.$toast) {
        this.$toast.success("Item added to bill");
      }
    },

    // Remove item from bill
    removeBillItem(itemId) {
      this.billItems = this.billItems.filter(item => item.id !== itemId);
    },

    // Reset billing form
    resetBillingForm() {
      this.selectedFeeAndCharge = null;
      this.billingForm = {
        quantity: 1,
        amount: 0,
        details: ''
      };
    },

    // Calculate total bill amount
    calculateTotalAmount() {
      return this.billItems.reduce((total, item) => total + item.totalAmount, 0);
    },

    // Prepare bill items for submission
    prepareBillItems() {
      this.billItem = []; // Reset the bill item array

      for (const { incomeTypeDescription, feeId, feeDescription, unitAmount, accountNo, costCenterNo, incomeTypeId, quantity, totalAmount } of this.billItems) {
        this.billItem.push({
          fiscalYear: new Date().getFullYear(),
          typeDescription: incomeTypeDescription,
          feeDescription,
          quantity,
          unitFeeAmount: unitAmount,
          accountNo,
          costCenterNo,
          incomeTypeId,
          revenueStreamItem: "",
          feeId,
          amount: totalAmount,
          customer: this.plotDetails.LRNumber,
          zone: this.plotDetails.zone || "",
          subCountyID: this.plotDetails.subCountyID,
          subCountyName: this.plotDetails.subCountyName,
          wardID: this.plotDetails.wardID,
          wardName: this.plotDetails.wardName,
          idNo: sessionStorage.getItem("sessionIdNo"),
          phoneNumber: sessionStorage.getItem("sessionPhoneNumber"),
          names: sessionStorage.getItem("sessionNames"),
          customerPhoneNumber: this.plotDetails.ownerPhoneNo,
          description: "",
          customerName: this.plotDetails.ownerNames
        });
      }

      return this.billItem;
    },

    // Generate bill
    generateBill() {
      const billItems = this.prepareBillItems();

      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("billItem", JSON.stringify(billItems));

      return execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              // Store the bill number for reference
              this.generatedBillNo = res.data.data.billGenerated.billNo;

              // Print the bill
              this.printBill(this.generatedBillNo);

              // Return the bill number for chaining
              return this.generatedBillNo;
            } else {
              throw new Error(res.data.message || "Failed to generate bill");
            }
          });
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      });
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    // Document Management Methods
    addDocument() {
      const newDoc = {
        id: Date.now(), // Unique ID for the document
        fileId: `doc_${Date.now()}`, // Unique ID for the file input
        documentType: '',
        documentNumber: '',
        expiryDate: '',
        file: null,
        fileName: '',
        fileSize: 0,
        uploadProgress: 0,
        error: ''
      };

      this.uploadedDocuments.push(newDoc);
    },

    handleDocumentChange(docId, event) {
      const docIndex = this.uploadedDocuments.findIndex(doc => doc.id === docId);
      if (docIndex === -1) return;

      const file = event.target.files[0];
      if (!file) return;

      // Check file size (max 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (file.size > maxSize) {
        this.uploadedDocuments[docIndex].error = 'File size exceeds 10MB limit';
        return;
      }

      // Check file type (PDF, JPG, PNG, DWG, etc.)
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'application/dwg', 'application/dxf'];
      if (!allowedTypes.includes(file.type) && !file.name.endsWith('.dwg') && !file.name.endsWith('.dxf')) {
        this.uploadedDocuments[docIndex].error = 'Invalid file type. Please upload PDF, JPG, PNG, DWG, or DXF files';
        return;
      }

      // Update document information
      this.uploadedDocuments[docIndex].file = file;
      this.uploadedDocuments[docIndex].fileName = file.name;
      this.uploadedDocuments[docIndex].fileSize = file.size;
      this.uploadedDocuments[docIndex].error = '';
    },

    removeDocument(docId) {
      this.uploadedDocuments = this.uploadedDocuments.filter(doc => doc.id !== docId);
    },

    validateDocumentUploads() {
      if (this.uploadedDocuments.length === 0) {
        if (this.$toast) {
          this.$toast.warning('Please upload at least one document');
        }
        return false;
      }

      for (const doc of this.uploadedDocuments) {
        if (!doc.documentType) {
          if (this.$toast) {
            this.$toast.warning(`Please select document type for "${doc.fileName || 'Unnamed document'}"`);
          }
          return false;
        }

        if (!doc.file) {
          if (this.$toast) {
            this.$toast.warning(`Please select a file for document type "${doc.documentType}"`);
          }
          return false;
        }

        if (doc.error) {
          if (this.$toast) {
            this.$toast.warning(`Please fix the error for "${doc.fileName}": ${doc.error}`);
          }
          return false;
        }
      }

      return true;
    },

    // Form validation before submission
    validateForm() {
      // Create array to collect all validation errors
      const errors = [];

      // Check required fields in main form
      if (!this.formData.developmentType) {
        errors.push("Please select a development type");
      }

      if (!this.formData.projectTitle) {
        errors.push("Please enter a project title");
      }

      if (!this.formData.professionalType || !this.formData.certificateNumber) {
        errors.push("Please select a professional type and enter certificate number");
      }

      if (!this.plotNumber) {
        errors.push("Please enter a plot number");
      } else if (!this.showPlotDetails) {
        errors.push("Please search and select a valid plot");
      }

      if (!this.formData.projectDescription) {
        errors.push("Please enter a project description");
      }

      // Check billing information
      if (this.billItems.length === 0) {
        errors.push("Please add at least one billing item");
      }

      // Validate document uploads
      if (this.uploadedDocuments.length === 0) {
        errors.push("Please upload at least one document");
      } else {
        // Check each document for completeness
        for (const doc of this.uploadedDocuments) {
          if (!doc.documentType) {
            errors.push(`Please select document type for "${doc.fileName || 'Unnamed document'}"`);
          }

          if (!doc.file) {
            errors.push(`Please select a file for document type "${doc.documentType || 'Unnamed document type'}"`);
          }

          if (doc.error) {
            errors.push(`Please fix the error for "${doc.fileName || 'Unnamed document'}": ${doc.error}`);
          }
        }
      }

      // If there are errors, display them to the user
      if (errors.length > 0) {
        // Try different methods to ensure the user sees the errors

        // 1. Use toast notifications if available
        if (this.$toast) {
          this.$toast.error(errors[0]); // Show at least the first error
        }

        // 2. Always show alert with all errors for visibility
        alert('Please fix the following errors:\n• ' + errors.join('\n• '));

        // 3. Log errors to console for debugging
        console.error('Validation errors:', errors);

        return false;
      }

      return true;
    },

    // Submit application
    // Submit application
    async submitApplication() {
      try {
        // First validate form
        if (!this.validateForm()) {
          return;
        }

        // Show loading state
        this.isSubmitting = true;

        // First generate bill
        const billNo = await this.generateBill();
        if (!billNo) {
          throw new Error("Failed to generate bill");
        }

        // Prepare application data
        const applicationData = {
          // Main application details
          developmentType: this.formData.developmentType,
          projectTitle: this.formData.projectTitle,
          projectValue: this.formData.projectValue,
          projectDescription: this.formData.projectDescription,
          professionalId: this.formData.professionalId || this.formData.certificateNumber,
          plotNumber: this.plotDetails.LRNumber || this.plotNumber,
          sessionNames: sessionStorage.getItem("sessionNames"),
          sessionIdNo: sessionStorage.getItem("sessionIdNo"),

          // Plot details
          plotDetails: this.formData.plotDetails,

          // Bill number reference
          billNumber: billNo,

          // Document information
          documents: this.uploadedDocuments.map(doc => ({
            fileId: doc.fileId,
            documentType: doc.documentType,
            documentNumber: doc.documentNumber,
            expiryDate: doc.expiryDate,
            fileName: doc.fileName
          }))
        };

        // Create FormData for submission
        const formData = new FormData();
        formData.append("function", "submitApplication");
        formData.append("applicationData", JSON.stringify(applicationData));

        // Add document files
        this.uploadedDocuments.forEach(doc => {
          if (doc.file) {
            formData.append(doc.fileId, doc.file);
          }
        });

        // Submit application
        const response = await execute(formData, econstruction);

        this.isSubmitting = false;

        if (response.data.success) {
          // Store application information
          this.applicationId = response.data.data.applicationId;
          this.applicationNumber = response.data.data.applicationNumber || "APP-" + response.data.data.applicationId;

          // Show success message
          if (this.$toast) {
            this.$toast.success(response.data.message || "Application submitted successfully!");
          }

          // Show success alert if SweetAlert is not available
          this.showApplicationSuccessModal();
        } else {
          throw new Error(response.data.message || "Failed to submit application");
        }
      } catch (error) {
        this.isSubmitting = false;

        // Show error message
        if (this.$toast) {
          this.$toast.error(error.message || "An error occurred while submitting the application");
        } else {
          alert("Error: " + (error.message || "An error occurred while submitting the application"));
        }

        console.error("Application submission error:", error);
      }
    },

    // Show application success modal
    // Show application success modal
    showApplicationSuccessModal() {
      // Check if SweetAlert is available
      if (this.$swal) {
        this.$swal({
          title: 'Application Submitted!',
          html: `
        <div class="text-start">
          <p>Your construction permit application has been successfully submitted.</p>
          <p><strong>Application Number:</strong> ${this.applicationNumber || 'APP-' + this.applicationId}</p>
          <p><strong>Project Title:</strong> ${this.formData.projectTitle}</p>
          <p>You can track the status of your application using the application number.</p>
        </div>
      `,
          icon: 'success',
          showCancelButton: true,
          confirmButtonText: 'View Application Details',
          cancelButtonText: 'Submit New Application'
        }).then((result) => {
          if (result.isConfirmed) {
            // Navigate to application details
            this.$router.push({
              name: 'applicationDetails',
              params: { id: this.applicationId }
            });
          } else {
            // Reset form for new application
            this.resetForm();
          }
        });
      } else {
        // Fallback if SweetAlert isn't available
        const confirmed = confirm(`
      Application Submitted Successfully!

      Application Number: ${this.applicationNumber || 'APP-' + this.applicationId}
      Project Title: ${this.formData.projectTitle}

      Click OK to view application details or Cancel to submit a new application.
    `);

        if (confirmed) {
          // Navigate to application details
          this.$router.push({
            name: 'applicationDetails',
            params: { id: this.applicationId }
          });
        } else {
          // Reset form for new application
          this.resetForm();
        }
      }
    },
    // Reset form for new application
    resetForm() {
      // Reset main form data
      this.formData = {
        // Application Details
        developmentType: '',
        projectTitle: '',
        projectValue: '',
        projectDescription: '',

        // Professional Details
        professionalType: '',
        certificateNumber: '',
        professionalFullNames: '',
        professionalOtherNames: '',
        professionalPhoneNumber: '',
        professionalEmail: '',
        professionalIdNumber: '',
        professionalId: null,

        // Plot Details
        plotDetails: {
          upnNumber: '',
          plotSize: '',
          landValue: '',
          annualLandRateCharges: '',
          currentBalance: '',
          landType: '',
          landUse: '',
          ownerFullNames: '',
          ownerIdNumber: '',
          ownerPhoneNumber: '',
          ownerEmail: '',
          ownerKraPin: '',
          ownerAddress: '',
          subCounty: '',
          ward: ''
        }
      };

      // Reset plot search
      this.plotNumber = '';
      this.plotSearchError = '';
      this.showPlotDetails = false;
      this.plotDetails = {};

      // Reset billing information
      this.selectedIncomeType = null;
      this.selectedFeeAndCharge = null;
      this.billItems = [];
      this.billingForm = {
        quantity: 1,
        amount: 0,
        details: ''
      };

      // Reset document uploads
      this.uploadedDocuments = [];

      // Reset application ID and number
      this.applicationId = null;
      this.applicationNumber = null;
      this.generatedBillNo = null;

      // Reset any error messages
      this.professionalSearchError = '';

      // Return to the first step
      // Get all step containers
      const stepContainers = document.querySelectorAll('.step-cont');

      // Hide all steps and show only the first one
      stepContainers.forEach((container, index) => {
        if (index === 0) {
          container.classList.add('active-step');
          container.classList.remove('d-none');
        } else {
          container.classList.remove('active-step');
          container.classList.add('d-none');
        }
      });

      // Update navigation
      const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
      navLinks.forEach((link, index) => {
        if (index === 0) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });

      // Reset buttons
      const prevButton = document.querySelector('.kev-prev');
      const nextButton = document.querySelector('.kev-nxt');
      const submitButton = document.querySelector('.kev-submit');

      if (prevButton) prevButton.disabled = true;
      if (nextButton) nextButton.classList.remove('d-none');
      if (submitButton) submitButton.classList.add('d-none');

      // Scroll to top
      window.scrollTo(0, 0);

      // Show a toast notification if available
      if (this.$toast) {
        this.$toast.info('Form has been reset for a new application');
      }
    },

    // Professional Management Methods
    validateProfessionalForm() {
      this.formErrors = {};
      let isValid = true;

      // Check required fields
      const requiredFields = ['professionalType', 'certificateNumber', 'fullNames', 'phoneNumber', 'emailAddress', 'idNumber', 'certificationExpiry'];

      requiredFields.forEach(field => {
        if (!this.professionalForm[field]) {
          this.formErrors[field] = 'This field is required';
          isValid = false;
        }
      });

      // Validate email format
      if (this.professionalForm.emailAddress && !/^\S+@\S+\.\S+$/.test(this.professionalForm.emailAddress)) {
        this.formErrors.emailAddress = 'Please enter a valid email address';
        isValid = false;
      }

      // Validate phone format (simple check)
      if (this.professionalForm.phoneNumber && !/^\+?[0-9]{10,15}$/.test(this.professionalForm.phoneNumber)) {
        this.formErrors.phoneNumber = 'Please enter a valid phone number';
        isValid = false;
      }

      return isValid;
    },

    addProfessional(event) {
      if (!this.validateProfessionalForm()) {
        this.submitStatus = 'error';
        this.submitMessage = 'Please correct the errors in the form';
        return;
      }

      this.isSubmitting = true;
      this.submitStatus = null;
      this.submitMessage = '';

      const data = new FormData();
      data.append("function", "addProfessional");

      // Append all form fields
      Object.keys(this.professionalForm).forEach(key => {
        if (key === 'certificationFile' && this.professionalForm[key]) {
          data.append('certificationFile', this.professionalForm[key]);
        } else if (this.professionalForm[key] !== null) {
          data.append(key, this.professionalForm[key]);
        }
      });

      // Add session information if available
      if (this.$store && this.$store.state.user) {
        data.append('sessionNames', this.$store.state.user.fullName || '');
        data.append('sessionIdNo', this.$store.state.user.idNumber || '');
      }

      execute(data, econstruction)
          .then((res) => {
            this.isSubmitting = false;

            if (res.data.success) {
              this.submitStatus = 'success';
              this.submitMessage = res.data.message || 'Professional added successfully';

              // Update fields in parent form
              this.updateMainFormWithProfessional(res.data.data);

              // Close modal
              setTimeout(() => {
                $('#addProfessionalModal').modal('hide');
                this.resetProfessionalForm();
              }, 1500);
            } else {
              this.submitStatus = 'error';
              this.submitMessage = res.data.message || 'Failed to add professional';
            }
          })
          .catch((e) => {
            this.isSubmitting = false;
            this.submitStatus = 'error';
            this.submitMessage = e.message || 'An error occurred while processing your request';
          });
    },

    handleFileChange(event) {
      this.professionalForm.certificationFile = event.target.files[0] || null;
    },

    resetProfessionalForm() {
      this.professionalForm = {
        professionalType: '',
        certificateNumber: '',
        fullNames: '',
        otherNames: '',
        phoneNumber: '',
        emailAddress: '',
        idNumber: '',
        certificationExpiry: '',
        certificationFile: null
      };
      this.formErrors = {};
      this.submitStatus = null;
      this.submitMessage = '';

      // Reset file input
      const fileInput = document.getElementById('modalCertificationFile');
      if (fileInput) fileInput.value = '';
    },

    updateMainFormWithProfessional(professionalData) {
      // Update the main form with professional information using v-model
      this.formData.professionalType = this.professionalForm.professionalType;
      this.formData.certificateNumber = this.professionalForm.certificateNumber;
      this.formData.professionalFullNames = this.professionalForm.fullNames;
      this.formData.professionalOtherNames = this.professionalForm.otherNames;
      this.formData.professionalPhoneNumber = this.professionalForm.phoneNumber;
      this.formData.professionalEmail = this.professionalForm.emailAddress;
      this.formData.professionalIdNumber = this.professionalForm.idNumber;
      this.formData.professionalId = professionalData.professional_id;
    }
  }
}
</script>

<style scoped>
.navbar-nav a.active::before {
  content: "";
  position: absolute;
  width: 40px;
  height: 3px;
  color: black;
  bottom: 0px;
  left: 0px;
  /* z-index: 100; */
  background-color: #556ee6;
  left: .5rem;
}

.navbar-nav a.active {
  color: #556ee6 !important;
  position: relative;
}

.step-navigation {
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 10px 15px;
  margin-bottom: 20px;
}

.step-navigation .nav-item {
  position: relative;
  padding: 8px 15px;
  border-radius: 4px;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.step-navigation .nav-link {
  color: #6c757d;
  font-weight: 500;
  transition: all 0.3s ease;
}

.step-navigation .nav-item.active {
  background-color: #1a56db; /* Darker blue background */
}

.step-navigation .nav-item.active .nav-link {
  color: #ffffff; /* White text for contrast */
  font-weight: 600;
}

/* Connector line between steps */
.step-navigation .nav-item:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -10px;
  width: 10px;
  height: 2px;
  background-color: #dee2e6;
}

/* Completed step styling */
.step-navigation .nav-item.completed {
  background-color: #e6f0ff;
}

.step-navigation .nav-item.completed .nav-link {
  color: #1a56db;
}

/* Step number styling */
.step-number {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background-color: #e9ecef;
  color: #495057;
  margin-right: 8px;
  font-size: 12px;
  font-weight: 600;
}

.nav-item.active .step-number {
  background-color: #ffffff;
  color: #1a56db;
}

.nav-item.completed .step-number {
  background-color: #1a56db;
  color: #ffffff;
}
</style>